import React, { useEffect, useState } from "react";
import Fixedbg from "../FixedBaground/Fixedbg.js";
import Header from '../Header/header';
import { Link } from "react-router-dom";
import '@/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import Footer from "../Footer/footer";
import Header4 from "../Header4/header4";
import Loading from "@/components/Loading";
import Loader from "react-loader";
import axios from "axios";
import { API_BASE_URL } from "@/config/serverApiConfig";

const EmailTwo = () =>{

    const [loaded, setLoaded] = useState(false);
    const [submitLoader, setSubmitLoader] = useState(true);

    useEffect(() => {
        // get id from url
        const id = window.location.pathname.split("/")[2];
        // get user data from api
        axios.get(`${API_BASE_URL}user/verify-emailTwo/${id}`).then(res => {
            setLoaded(true);
            setSubmitLoader(false);
        }
        ).catch(err => {
            setLoaded(true);
            setSubmitLoader(false);
        }
        );
    }, []);


  return(
<>
{/* <Header/> */}
<div className="container">
            <div className="row">
                 <div className="col-md-6 offset-md-3">
                     <div style={{"textAlign": "center",
    "marginTop": "40px"}} className="logo">

                  <img src="../assets/images/logo_black.png" alt="logo" className="logocenter" />
                  </div>
                  <div style={{ marginBottom: "600px"}}>
                    { submitLoader ? 
         <div style={{textAlign: "center", color: "#9F7854", marginTop: "200px"}} className="text-center"><Loader
         loaded={loaded}
         lines={13}
         length={20}
         width={10}
         radius={30}
         corners={1}
         rotate={0}
         direction={1}
         color="#000"
         speed={1}
         trail={60}
         shadow={false}
         hwaccel={false}
         className="spinner"
         zIndex={2e9}
         top="50%"
         left="50%"
         scale={1.0}
         loadedClassName="loadedContent"
       /> </div>:
        <div className=" text-center" >
                    <h1 style={{textAlign: "center", color: "#9F7854", marginTop: "200px"}} className="mb-5">Verification Successful </h1>
               </div> } 
               </div>
                </div> 
            </div> 
        </div>
        
</>
  )}
export default EmailTwo;